var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatacubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.25V2.75L11 0L5.5 2.75V8.25L0 11V17.875L5.5 20.625L11 17.875L16.5 20.625L22 17.875V11L16.5 8.25ZM11.1238 1.54L15.125 3.52L11.55 5.3075L7.54875 3.3275L11.1238 1.54ZM6.875 3.8225L11 5.885V10.835L6.875 8.7725V3.8225ZM5.5 19.085L1.375 17.0225V12.0725L5.5 14.135V19.085ZM5.885 13.585L1.925 11.5775L5.5 9.79L9.46 11.77L5.885 13.585ZM16.5 19.085L12.375 17.0225V12.0725L16.5 14.135V19.085ZM16.885 13.585L12.925 11.5775L16.5 9.79L20.46 11.77L16.885 13.585Z",
    fill: "url(#paint0_linear_6775_16049)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6775_16049",
    x1: 18.7429,
    y1: 35.9311,
    x2: -6.50293,
    y2: 30.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacubeIcon);
export default __webpack_public_path__ + "static/media/datacube-icon.f20375bd08fa08c28892273cf3f33ad0.svg";
export { ForwardRef as ReactComponent };